import type { DashboardBrand } from "../lib/api";
import { SiteRow } from "./SiteRow";

export function BrandGroup({ brand }: { brand: DashboardBrand }) {
  if (brand.sites.length === 0) return null;

  return (
    <section className="mb-12">
      <header className="flex items-baseline gap-3 mb-3 pb-3 border-b border-border">
        <h3 className="font-mono text-xs tracking-editorial text-muted uppercase">
          {brand.displayName}
        </h3>
        <span className="font-mono text-[10px] text-faint">
          {brand.sites.length} {brand.sites.length === 1 ? "site" : "sites"}
        </span>
      </header>

      <div>
        {brand.sites.map((site) => (
          <SiteRow key={site.id} site={site} />
        ))}
      </div>
    </section>
  );
}
